<template>
  <v-container>
    <!-- Llistat maquines -->
    <v-simple-table class="mt-12">
      <thead>
        <v-row>
          <v-col sm="8" offset-sm="1">
            <h1>Llistat de Màquines</h1>
          </v-col>
          <v-col sm="1" offset-sm="0">
            <!-- Dialog/Modal per crear maquines -->
            <v-dialog v-model="dialogMaquina" persistent max-width="600">
              <template v-slot:activator="{ on }">
                <v-btn block color="success" dark v-on="on">+</v-btn>
              </template>
              <v-card>
                <v-card-title class="headline">Crear fàbrica</v-card-title>
                <v-container>
                  <v-form id="formMaquina" ref="formMaquina" class="mt-12">
                    <v-row>
                      <v-col md="12">
                        <v-text-field v-model="maquina_nova.numero" label="Número" required></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12">
                        <v-text-field v-model="maquina_nova.fabrica" label="Fábrica" required></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
                <v-card-actions>
                  <v-btn color="green darken-1" text @click="tancarCrearMaquina">Cancel·lar</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green darken-1"
                    text
                    @click="btnCrearMaquina"
                    :disabled="!maquina_nova.numero || !maquina_nova.fabrica"
                  >Crear</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- ./Dialog/Modal per crear fàbrica -->
          </v-col>
        </v-row>
      </thead>
      <tbody>
        <tr v-for="maquina in maquines" :key="maquina.id">
          <td class="text-maquina">
            <div @click="maquinaDetail(maquina.id)">Fàbrica: {{textFabrica(maquina.fabrica)}} - Número: {{ maquina.numero }}</div>
            <div>
              <v-btn color="error" dark @click="btnModalEliminar(maquina.id)">Eliminar</v-btn>
            </div>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <!-- ./Llistat Fàbriques -->
    <!-- Dialog/Modal per eliminar fàbrica -->
    <v-dialog v-model="dialogEliminarMaquina" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Eliminar fàbrica</v-card-title>
        <v-card-actions>
          <v-btn color="green darken-1" text @click="dialogEliminarMaquina = false">Cancel·lar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="btnEliminarMaquina()">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ./Dialog/Modal per eliminar fàbrica -->
    <!-- Paginació -->
    <v-pagination
      v-model="pagina"
      :length="totalPagines"
      @input="paginar()"
      v-if="totalPagines > 1"
    ></v-pagination>
    <!-- ./Paginació -->
    <!-- Footer -->
    <v-footer class="font-weight-medium" height="38%">
      <v-col class="text-center" cols="12" @click="redireccio('Home')" style="padding:0px">
        <span>Gestió Integral Borreres, {{ new Date().getFullYear() }}</span>
      </v-col>
    </v-footer>
    <!-- ./Footer -->
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { EventBus } from "@/event-bus.js";

export default {
  name: "maquina-llistat",
  data: () => ({
    dialogMaquina: false,
    dialogEliminarMaquina: false,
    maquinaEliminarID: null,
    maquina_nova: {
      nom: "",
      prefix: "",
    },
    pagina: 1,
    totalPagines: 1
  }),
  computed: {
    ...mapGetters({
      maquines: "getMaquinas", 
      fabriques: "getFabriques"
    })
  },
  methods: {
    ...mapActions(["eliminarMaquina", "getMaquinas","getFabriques", "sendMaquina"]),

    // Paginació
    paginar() {
      this.filtre.pagina = this.pagina;
    },

    // Edició de fàbrica
    btnCrearMaquina() {
      this.sendMaquina(this.maquina_nova).then(maquina => {
        this.pagina = maquina
        if (maquina == 201) {
          this.tancarCrearMaquina();
        }
      });
    },
    btnModalEliminar(maquina) {
      this.dialogEliminarMaquina = true;
      this.maquinaEliminarID = maquina;
    },
    textFabrica(fabricaID) {
      return this.fabriques.find(el => el.id === fabricaID)?.nom;
    },

    btnEliminarMaquina() {
      this.eliminarMaquina(this.maquinaEliminarID).then(response => {
        if (response === 204) {
          EventBus.$emit("Maquina.Notificacio", {
            text: "Maquina eliminat correctament",
            color: "success"
          });
          this.dialogEliminarMaquina = false;
          this.maquinaEliminarID = null;
        } else
          EventBus.$emit("Maquina.Notificacio", {
            text: "Error eliminant el maquina",
            color: "error"
          });
      });
    },

    // Rerouting
    maquinaDetail(maquinaID) {
      this.$router.push({
        name: "MaquinaDetail",
        params: { id: maquinaID }
      });
    },
    redireccio(component) {
      this.$router.push({ name: component });
    },

    // Auxiliars
    tancarCrearMaquina() {
      this.maquina_nova = {
        nom: "",
        prefix: "",
      };
      this.dialogMaquina = false;
    }
  },
  created() {
    this.getMaquinas();
    this.getFabriques();
  }
};
</script>
<style lang="scss" scoped>
h1 {
  text-align: center;
  padding-bottom: 1em;
}
.text-maquina {
  text-align: center;
  font-size: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;

  div:first-child {
    width: 80%;
  }
  div:nth-child(2) {
    width: 20%;
  }
}
th {
  text-align: right !important;
}
.row {
  margin: 0px;
}
.v-pagination {
  padding-bottom: 50px;
}
</style>